<template>
  <div class="childtrackingsystem-editchildobservationlist">
      <div class="row bg-white">
        <br>
      </div>
      <div v-if="isLoading" class="row bg-white">
          <div class="col-12 text-center">
              <img
                  src="../../assets/img/loading.gif"
                  alt="Loading"
                  style="width: 80px; height: 80px;"
              >
          </div>
      </div>
      <div class="row bg-white" v-if="isError">
      <div class="col-12 alert alert-danger text-center">{{ errorMessage }}</div>
    </div>
    <div class="row bg-white" v-if="isSuccess">
      <div class="col-12 alert alert-info text-center">Observatie is succesvol opgeslagen</div>
    </div>
    <div class="row bg-white">
      <div class="col-10 pt-2"><b>{{ listTitle }}</b> van kind <b>{{ child.full_name }}</b> ({{ child.age }} maanden)</div>
      <div class="col-2 text-end pe-1 pt-2">
        <button class="btn btn-outline-secondary" @click="goBack()">Terug</button>
      </div>
    </div>
    <div class="row bg-white pt-3">
      <div class="col-12">
        <input
            id="searchQuestion"
            v-model="searchQuestion"
            type="text"
            class="form-control"
            placeholder="Zoek een doel"
            value=""
            @input="getResults()"
        ><br>
      </div>
    </div>
    <div
        id="cts-content"
        class="row bg-white"
    >
      <div class="col-12">
        <table
            v-for="(category, cIdx) in categories"
            :key="cIdx"
            style="border:0;width:100%;"
        >
          <tr v-if="category.questions.length > 0" class="header">
            <th
                :style="'border:0; height: 50px; padding-left: 15px;color:' + category.color"
                colspan="3"
            >
              {{ cIdx + 1 }}. {{ category.name }}
            </th>
          </tr>
          <tr
              v-for="(question, cqIdx) in category.questions"
              :key="cqIdx"
              class="borderBottomShadow"
          >
            <td style="border:0;width:15px;">
              &nbsp;&nbsp;
            </td>
            <td style="border:0;padding-top:10px;vertical-align: middle;margin-right: 15px; padding-left: 15px;">
              {{ question.vraag }}
            </td>
            <td style="border:0;width:300px;padding-top:10px;vertical-align: middle;">
              <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                <tr>
                  <td
                      v-for="answer in question.answerPossibilities"
                      :key="answer.id"
                  >
                    <input v-if="!question.freeAnswer"
                           type="radio"
                           :id="'checkedAnswer-' + idList + '-' + child.id + '-' + question.id + '-' + answer.id"
                           :name="'checkedAnswer-' + idList + '-' + child.id + '-' + question.id"
                           :checked="answer.id === question.checkedAnswer"
                           @input="changeAnswer(idList, child.id, question.id, answer.id, answer.note)"
                    />
                    <span v-if="!question.freeAnswer"
                          style="margin-left:5px;margin-right:5px;"
                          @click="setAnswerChecked(idList, child.id, question.id, answer.id, answer.note);">
                      {{ answer.answer }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td :colspan="question.answerPossibilities.length">
                    <textarea v-if="!question.freeAnswer"
                              :id="'answerNote-' + idList + '-' + child.id + '-' + question.id"
                              :ref="'answerNote-' + idList + '-' + child.id + '-' + question.id"
                              v-model="answerNote[idList][child.id][question.id]"
                              class="form-control"
                              :style="'width:100%;height: 50px; display:' + question.displayAnswerNote"
                              @input="changeAnswerNote($event, idList, child.id, question.id, question.freeAnswer, question.checkedAnswer)"
                    />
                    <textarea v-if="question.freeAnswer"
                              :id="'answerNote-' + idList + '-' + child.id + '-' + question.id"
                              :ref="'answerNote-' + idList + '-' + child.id + '-' + question.id"
                              v-model="answerNote[idList][child.id][question.id]"
                              class="form-control"
                              :style="'width:100%;height: 50px; display:' + question.displayAnswerNote"
                              @input="changeAnswerNote($event, idList, child.id, question.id, question.freeAnswer, question.checkedAnswer)"
                    />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <table
                  v-for="(subCategory, scIdx) in category.subcategories"
                  :key="scIdx"
                  style="border:0;width:100%;"
              >
                <tr class="header">
                  <th
                      :style="'border:0; height: 50px; padding-left: 15px;color:' + category.color"
                      colspan="3"
                  >
                    {{ category.name }}: {{ subCategory.name }}
                  </th>
                </tr>
                <tr
                    v-for="(subQuestion, scqIdx) in subCategory.questions"
                    :key="scqIdx"
                    class="borderBottomShadow"
                >
                  <td style="border:0;width:15px;">
                    &nbsp;&nbsp;
                  </td>
                  <td style="border:0;padding-top:10px;padding-left:10px;vertical-align: middle;margin-right: 15px;">
                    {{ subQuestion.vraag }}
                  </td>
                  <td style="border:0;width:300px;padding-top:10px;vertical-align: middle;">
                    <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                      <tr>
                        <td
                            v-for="answer in subQuestion.answerPossibilities"
                            :key="answer.id"
                        >
                          <input v-if="!subQuestion.freeAnswer"
                                 type="radio"
                                 :checked="subQuestion.checkedAnswer === answer.id"
                                 :id="'checkedAnswer-' + idList + '-' + child.id + '-' + subQuestion.id + '-' + answer.id"
                                 :name="'checkedAnswer-' + idList + '-' + child.id + '-' + subQuestion.id"
                                 @input="changeAnswer(idList, child.id, subQuestion.id, answer.id, answer.note)"
                          />
                          <span v-if="!subQuestion.freeAnswer"
                                style="margin-left:5px;margin-right:5px;"
                                @click="setAnswerChecked(idList, child.id, subQuestion.id, answer.id, answer.note);">
                          {{ answer.answer }}
                        </span>
                        </td>
                      </tr>
                      <tr>
                        <td :colspan="subQuestion.answerPossibilities.length">
                    <textarea v-if="!subQuestion.freeAnswer"
                              id="'answerNote-' + child.id + '-' + subQuestion.id"
                              :ref="'answerNote-' + idList + '-' + child.id + '-' + subQuestion.id"
                              v-model="answerNote[idList][child.id][subQuestion.id]"
                              class="form-control"
                              :style="'width:100%;height: 50px; display:' + subQuestion.displayAnswerNote"
                              @input="changeAnswerNote($event, idList, child.id, subQuestion.id, subQuestion.freeAnswer, subQuestion.checkedAnswer)"
                    />
                          <textarea v-if="subQuestion.freeAnswer"
                                    id="'answerNote-' + child.id + '-' + subQuestion.id"
                                    v-model="answerNote[idList][child.id][subQuestion.id]"
                                    :ref="'answerNote-' + idList + '-' + child.id + '-' + subQuestion.id"
                                    class="form-control"
                                    :style="'width:100%;height: 50px; display:' + subQuestion.displayAnswerNote"
                                    @input="changeAnswerNote($event, idList, child.id, subQuestion.id, subQuestion.freeAnswer, subQuestion.checkedAnswer)"
                          />
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td
                style="border:0;vertical-align: top;padding: 10px; "
                colspan="3"
            >
              <div v-if="category.noteChecked === 'checked'">
                <b>{{ category.name }} opmerkingen</b>
                <textarea
                    :id="'categoryNote-' + idList + '-' + child.id + '-' +category.id"
                    v-model="categoryNote[idList][child.id][category.id]"
                    class="form-control"
                    style="height: 100px;"
                    @input="changeCategoryNote($event, idList, child.id, category.id)"
                />
              </div>
            </td>
          </tr>
          <tr v-if="!hasEndForm">
            <td
                style="border:0;"
                colspan="3"
            >
              <button
                  :id="'upload-' + category.id"
                  type="button"
                  class="btn btn-outline-warning"
                  @click="uploadPhoto($event,idResult, category.id)"
              >
                Upload foto's
              </button>
              <button
                  :id="'add-' + category.id"
                  type="button"
                  class="btn btn-outline-warning"
                  style="margin-left: 15px;"
                  @click="addPhoto(idResult, category.id)"
              >
                Foto's toevoegen
              </button>
            </td>
          </tr>
          <tr>
            <td
                style="border:0;"
                colspan="3"
            >
                <span class="mt-2 me-2 text-center" v-for="image in categoryPhotos[category.id]"
                      :key="image.id" style="position: relative; height: 200px;">
              <img class="mb-2"
                   :src="image.src"
                   :title="image.filename"
                   :alt="image.filename"
                   height="150"/>
                  <button v-if="!hasEndForm"
                          class="btn btn-sm btn-danger delete-image"
                          @click="deleteImage(image.id)">
                    <icon name="delete"></icon>
                  </button>
                </span>
            </td>
          </tr>
          <tr v-if="category.previousQuestions && category.previousQuestions.length > 0">
            <td
                style="border:0;"
                colspan="3"
            >
              <div class="row bg-white">
                <div
                    v-for="listN in category.previousQuestions"
                    :key="listN.id"
                    class="col-12"
                >
                  <table style="border:0;width:100%;">
                    <tr class="preHeader">
                      <th style="height:50px;padding-left: 15px;">
                        Overgenomen doelen <br> {{ listN.title }} ({{ listN.age }})
                      </th>
                      <th/>
                    </tr>
                  </table>
                  <table
                      v-for="(categoryN, cnIdx) in listN.category"
                      :key="cnIdx"
                      style="border:0;width:100%;"
                  >
                    <tr
                        v-for="(questionN, cqIdx) in categoryN.questions"
                        :key="cqIdx"
                        class="borderBottomShadow"
                    >
                      <td style="border:0;width:15px;">
                        &nbsp;&nbsp;
                      </td>
                      <td style="border:0;padding-top:10px;vertical-align: middle;margin-right: 15px; padding-left: 15px;">
                        {{ questionN.vraag }}
                      </td>
                      <td style="border:0;width:300px;padding-top:10px;vertical-align: middle;">
                        <table style="width: 100%; border-spacing: 10px;border-collapse: separate; padding-right:10px;">
                          <tr>
                            <td
                                v-for="answerN in questionN.answerPossibilities"
                                :key="answerN.id"
                            >
                              <input v-if="!questionN.freeAnswer"
                                     :id="'checkedAnswer-' + listN.id + '-' + listN.childId + '-' + questionN.id + '-' + answerN.id"
                                     type="radio"
                                     :checked="answerN.id === questionN.checkedAnswer"
                                     :name="'checkedAnswer-' + listN.id + '-' + listN.childId + '-' + questionN.id"
                                     @input="changeAnswer(listN.id, listN.childId, questionN.id, answerN.id, answerN.note)"
                              >
                              <span v-if="!questionN.freeAnswer"
                                    style="margin-left:5px;margin-right:5px;"
                                    @click="setAnswerChecked(listN.id, listN.childId, questionN.id, answerN.id, answerN.note);"
                              > {{ answerN.answer }}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <textarea v-if="!questionN.freeAnswer"
                                        :id="'answerNote-' + listN.id + '-' + listN.childId + '-' + questionN.id"
                                        :ref="'answerNote-' + listN.id + '-' + listN.childId + '-' + questionN.id"
                                        v-model="answerNote[listN.id][listN.childId][questionN.id]"
                                        class="form-control"
                                        :style="'height: 50px; display: ' + questionN.displayAnswerNote"
                                        @input="changeAnswerNote($event, listN.id, listN.childId, questionN.id)"
                              />
                              <textarea v-if="questionN.freeAnswer"
                                        :id="'answerNote-' + listN.id + '-' + listN.childId + '-' + questionN.id"
                                        :ref="'answerNote-' + listN.id + '-' + listN.childId + '-' + questionN.id"
                                        v-model="answerNote[listN.id][listN.childId][questionN.id]"
                                        class="form-control"
                                        :style="'height: 50px; display: ' + questionN.displayAnswerNote"
                                        @input="changeAnswerNote($event, listN.id, listN.childId, questionN.id)"
                              />
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </td>
          </tr>
        </table>

        <br><br>
        <table
            v-if="noteChecked === 'checked'"
            style="width:95%; height:150px; margin-left: 15px; margin-right: 15px; border:0;"
        >
          <tr>
            <td colspan="2">
              <div>
                <b>Observatielijst opmerkingen</b><br>
                <textarea
                    id="listNote"
                    v-model="listNote[idList][child.id]"
                    class="text-input form-control"
                    style="height: 100px;"
                    @input="changeListNote($event, child.id)"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="row row-cols-auto align-items-end bg-white pb-2">
      <div class="col">
        <button
            class="btn btn-outline-secondary"
            @click="goBack()"
        >
          Terug
        </button>
      </div>
      <div class="col">
        <button class="btn btn-outline-secondary"
                v-if="resultActive"
                title="Zet in archief"
                @click="changeResultStatus(idResult, false)"
        >Zet in archief
        </button>
        <button class="btn btn-outline-secondary"
                v-if="!resultActive"
                title="Haal uit archief"
                @click="changeResultStatus(idResult, true)"
        >Haal uit archief
        </button>
        </div>
      <div class="col">
        <label class="form-label">Ingevuld door</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="mentor"
          placeholder="Zoek..."
          name="mentor"
          list="mentors-list"
          v-model="searchedMentor"
          @focus="searchedMentor = ''; document.getElementById('mentors-list').style.display='block';"
          @change="mentorChanged()"
        />
        <datalist id="mentors-list">
          <option value="Geen"></option>
          <option
            v-for="mentor in mentors"
            :value="mentor.name"
            :key="mentor.id"
          >
          </option>
        </datalist>
      </div>
        <div class="col">
          <button v-if="!hasEndForm"
                  class="btn btn-outline-primary"
                  @click="saveAnalyseChildren(false)"
          >
            Opslaan
          </button>
      </div>
    </div>
    <div class="row bg-white pb-2">
      <div class="col">
        <button class="btn btn-outline-primary ms-2" @click="saveAnalyseChildren(true)">Opslaan en definitief formulier maken</button>
      </div>
    </div>
    <div
        v-if="isModal"
        id="uploadModal"
        class="modalUploadLoader"
    >
      <div class="modal-content">
        <div
            class="modal-title"
            style="text-align: right; width:100%; padding: 10px;"
        >
          <button
              class="btn btn-danger"
              @click="closeModal()"
          >
            x
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group"  style="padding: 10px;">
            <div class="col-sm-10">
              Foto uploaden:
                <input
                    id="photo"
                    ref="photo"
                    type="file"
                    accept="image/jpeg"
                    class="form-control-file"
                    multiple="multiple"
                ><br>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
              class="btn btn-outline-primary"
              type="button"
              name="upload"
              value="upload"
              @click="uploadSave()"
          >
            Opslaan upload
          </button>
        </div>
      </div>
    </div>
    <div
        v-if="isAddModal"
        id="addModal"
        class="modalAddLoader"
    >
      <div class="modal-content">
        <div
            class="modal-title"
            style="text-align: right; width:100%; padding: 10px;"
        >
          <button
              class="btn btn-danger"
              @click="closeAddModal()"
          >
            x
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
              <div class="col">
                  <img
                      v-for="imageMedia in childMedia"
                      :id="'addImage-' + imageMedia.id"
                      :key="imageMedia.id"
                      :src="imageMedia.src"
                      :title="imageMedia.filename"
                      :alt="imageMedia.filename"
                      style="margin-right: 10px; height: 150px; border: 1pt solid black"
                      @click="selectPhotos(imageMedia.id, imageMedia.filename);"
                  />
              </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
              class="btn btn-outline-secondary"
              type="button"
              name="upload"
              value="upload"
              @click="addSave()"
          >
            Toevoegen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from "../../components/Icon.vue";

export default {
  name: 'ChildtrackingsystemEditchildobservationlist',
  components: {Icon},
  // eslint-disable-next-line vue/require-prop-types
  props: ['idResult'],
  data() {
    return {
      isLoading: false,
      child: [],
      listTitle: null,
      listNote: {},
      noteChecked: null,
      categories: [],
      answers: [],
      checkedAnswer: {},
      idList: false,
      checkedChild: this.$store.getters.selectedChild,
      categoryNote: {},
      answerNote: {},
      mentors: [],
      selectedMentor: null,
      searchedMentor: 'Geen',
      categoryName: null,
      isModal: false,
      isAddModal: false,
      upload_idCategory: null,
      add_idCategory: null,
      files: [],
      images: [],
      photos: [],
      categoryPhotos: [],
      listNoAnswer: [],
      searchQuestion: '',
      childMedia: [],
      selectedPhotos: [],
      addPhotoClass: [],
      selectedAnswers: 'all',
      isLoadNext: false,
      idChild: null,
      hasEndForm: false,
      lists: [],
      checkedChildren: [],
      resultActive: true,
      isError: false,
      errorMessage: null,
      isSuccess: false
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/getAnalyseChild', {
        idResult: this.idResult,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        question: this.searchQuestion
      }).then((response) => {
        if (response) {
          this.child = response.child
          this.listTitle = response.listTitle
          this.listNote = response.listNote
          this.noteChecked = response.noteChecked
          this.categories = response.content
          this.answerNote = response.answerNote
          this.categoryNote = response.categoryNote
          this.idList = response.idList
          this.lists.push(response.idList)
          this.checkedChildren.push(response.child.id)
          this.selectedMentor = response.selectedMentor
          this.mentors = response.mentors
          this.mentors.forEach(mentor => {
            if (mentor.id === this.selectedMentor) {
              this.searchedMentor = mentor.name
            }
          })
          this.hasEndForm = response.formFinal
          this.resultActive = response.resultActive
          this.categoryPhotos = response.categoryPhotos
        }
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        this.isLoading = false
      })
    },
    mentorChanged() {
      if (this.searchedMentor === '') {
        this.selectedMentor = 0;
      } else {
        this.mentors.forEach(mentor => {
          if (mentor.name.toLowerCase().includes(this.searchedMentor.toLowerCase())) {
            this.selectedMentor = mentor.id
          }
        })
      }
      document.activeElement.blur()
    },
    changeAnswer(listId, childId, questionId, answerId, answerNoteActive) {
      if (!this.lists.includes(listId)) {
        this.lists.push(listId)
      }
      this.checkedAnswer ||= {};
      this.checkedAnswer[listId] ||= {};
      this.checkedAnswer[listId][childId] ||= {};
      this.checkedAnswer[listId][childId][questionId] = answerId;
      let $ref = this.$refs['answerNote-' + listId + '-' + +childId + '-' + questionId]
      if (answerNoteActive === 'checked') {
        $ref[0].innerHTML = ''
        $ref[0].style.display = 'block'
      } else {
        $ref[0].innerHTML = ''
        $ref[0].style.display = 'none'
      }
    },
    changeAnswerNote(event, listId, childId, questionId, freeAnswer, answerId) {
      if (!this.lists.includes(listId)) {
        this.lists.push(listId)
      }
      this.answerNote ||= {};
      (this.answerNote[listId] ||= {})[childId] ||= {};
      this.answerNote[listId][childId][questionId] = event.target.value;
      if (freeAnswer) {
        this.checkedAnswer ||= {};
        this.checkedAnswer[listId] ||= {};
        this.checkedAnswer[listId][childId] ||= {};
        this.checkedAnswer[listId][childId][questionId] = answerId;
      }
    },
    changeCategoryNote(event, listId, childId, categoryId) {
      if (!this.lists.includes(listId)) {
        this.lists.push(listId)
      }
      this.categoryNote ||= {};
      (this.categoryNote[listId] ||= {})[childId] ||= {};
      this.categoryNote[listId][childId][categoryId] = event.target.value;
    },
    changeListNote(event, listId, childId) {
      this.listNote[listId] ||= {};
      this.listNote[listId][childId] = event.target.value
    },
    setAnswerChecked(listId, childId, questionId, answerId, answerNoteActive) {
      let id = 'checkedAnswer-'+ listId + '-' + childId + '-' + questionId + '-' + answerId
      document.getElementById(id).checked = true
      this.changeAnswer(listId, childId, questionId, answerId, answerNoteActive)
    },
    saveAnalyseChildren(makeForm) {
      this.isSuccess = false
      this.isError = false
      this.isLoading = true
      window.scrollTo(0, 0);
      this.$request.post('/ChildTrackingSystem/saveAnalyseChild', {
        answers: this.checkedAnswer,
        categoryNote: this.categoryNote,
        answerNote: this.answerNote,
        listNote: this.listNote,
        lists: this.lists,
        idMentor: this.selectedMentor,
        idResult: this.idResult,
        idChild: this.child.id,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        makeForm: makeForm
      }).then((response) => {
        this.isLoading = false
        if (response.success) {
           this.isSuccess = true
           setTimeout(() => this.isSuccess = false, 40000)
           if (response.savedChildForm['success']) {
             this.$router.push('/childtrackingsystem/editchildform/' + this.idResult + '/' + response.savedChildForm['idChildForm'])
           } else if (response.savedChildForm['error']) {
             this.isError = true
             this.errorMessage = 'Observatie is succesvol opgeslagen maar er is een fout opgetreden tijdens het opslaan van het observatieformulier. <br> Probeer later opnieuw'.
             setTimeout(() => this.isError = false, 40000)
           } else {
             this.getResults()
           }
        } else if (response.error) {
            this.isError = true
            this.errorMessage = response.error
            setTimeout(() => this.isError = false, 40000)
        }
      })
    },
    uploadPhoto(event, idResult, idCategory) {
      this.isModal = true
      this.upload_idCategory = idCategory
      this.upload_idResult = idResult
      window.scrollTo(0, 0);
    },
    addPhoto(idResult, idCategory) {
      this.isAddModal = true
      this.upload_idCategory = idCategory
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/getChildMedia', {
        idResult: idResult,
        idChild: this.idChild,
        idCategory: idCategory
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.media) {
          this.childMedia = response.media
          window.scrollTo(0, 0);
        } else {
          this.isAddModal = false
          alert('Geen photos beschikbaar in fotobibliotheek van dit kindje!')
        }
      })
    },
    selectPhotos(photoId, photoName) {
      if (this.selectedPhotos.includes(photoName)) {
        this.selectedPhotos.splice(this.selectedPhotos.indexOf(photoName), 1)
        document.getElementById("addImage-" + photoId).style.borderColor = 'black'
      } else {
        this.selectedPhotos.push(photoName)
        document.getElementById("addImage-" + photoId).style.borderColor = 'red'
      }
    },
    closeModal() {
      this.isModal = false
    },
    closeAddModal() {
      this.isAddModal = false
      this.selectedPhotos = []
    },
    uploadSave() {
      let files = this.$refs.photo.files
      for (let i = 0; i < files.length; i++) {
        let formData = new FormData();
        formData.append('file', files[i])
        formData.append('upload_idCategory', this.upload_idCategory)
        formData.append('upload_idResult', this.idResult)
        formData.append('idList', this.idList)

        this.$store.commit('REGISTER_ACTIVE_REQUEST')
        // eslint-disable-next-line no-undef
        this.$request.post('/ChildTrackingSystem/uploadPhoto', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then((response) => {
          this.$store.commit('REMOVE_ACTIVE_REQUEST')
          if (!response.uploaded) {
            alert(response.error)
          } else {
            this.categoryPhotos = response.categoryPhotos
          }
        })
      }
      this.isModal = false
    },
    deleteImage(image) {
      let formData = new FormData();
      formData.append('idPhoto', image)
      formData.append('idResult', this.idResult)
      formData.append('idList', this.idList)
      formData.append('session_token', this.session.session_token)
      formData.append('device_token', this.deviceToken)
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/deletePhoto', formData)
          .then((response) => {
            this.$store.commit('REMOVE_ACTIVE_REQUEST')
            if (!response) {
              alert("Er is een fout opgetreden tijdens het verwijderen van foto")
            } else {
              this.categoryPhotos = response.categoryPhotos
            }
          })
    },
    addSave() {
      let formData = new FormData();
      formData.append('photos', this.selectedPhotos)
      formData.append('session_token', this.session.session_token)
      formData.append('device_token', this.deviceToken)
      formData.append('idCategory', this.upload_idCategory)
      formData.append('idResult', this.idResult)
      formData.append('idList', this.idList)

      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/addPhoto', formData)
          .then((response) => {
            this.$store.commit('REMOVE_ACTIVE_REQUEST')
            if (!response) {
              alert("Er is een fout opgetreden tijdens toevoegen")
            } else {
              this.isAddModal = false
              this.categoryPhotos = response.categoryPhotos
              this.selectedPhotos = []
            }
          })
    },
    changeResultStatus(idResult, status) {
      this.isLoading = true
      this.resultActive = status
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/changeResultStatus', {
        idResult: idResult,
        idList: this.idList,
        status: status
      }).then((response) => {
        this.isLoading = false
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
          window.location.reload()
        }
      })
    },
    goBack() {
      window.location.reload()
    }
  }
}
</script>
<style scoped>

.modalLoader {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.modalUploadLoader {
  background-color: white;
  border: 1pt solid #ddd;
  position: absolute;
  z-index: 1;
  width: 480px;
  height: 200px;
  overflow: hidden;
  left: 250px;
  top: 250px;
}

.modalAddLoader {
  background-color: white;
  border: 1pt solid #ddd;
  position: absolute;
  z-index: 1;
  width: 480px;
  height: 300px;
  overflow: auto;
  left: 250px;
  top: 250px;
}

input[type=radio] {
  transform: scale(1.5, 1.5);
}

.borderBottomShadow {
  border-bottom: 1px #ddd solid;
  height: 100px;
}

.header {
  color: #445161;
  background-color: #f0f0f5;
}

.preHeader {
  color: #445161;
  background-color: #dedee7;
}

.delete-image {
  position: absolute;
  bottom: -80px;
  right: -10px;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
</style>